import { pdfjs } from 'react-pdf';

/**
 * Single setup point for the PDF.js worker.
 *
 * Each consuming app copies pdfjs-dist's LEGACY worker build into its build
 * output via a Vite plugin (see `copyPdfWorkerPlugin` in the app's
 * `vite.config.ts`). Legacy because it self-polyfills ES2024 APIs
 * (Promise.withResolvers) — the worker context can't see the app's own
 * polyfills, and the modern build crashed Safari < 17.4. The worker is
 * served from the same origin as the app — no runtime dependency on
 * unpkg.com CDN. The URL here must match the plugin's `outName`.
 *
 * The version is embedded in the filename so browsers cache-bust on upgrades.
 *
 * `import.meta.env.BASE_URL` is Vite's built-in base path (defaults to "/").
 * If an app ever sets `base: '/subpath/'` in vite.config.ts, the worker URL
 * will resolve correctly without code changes here.
 */
pdfjs.GlobalWorkerOptions.workerSrc = `${import.meta.env.BASE_URL}pdf.worker.${pdfjs.version}.legacy.min.mjs`;
